<template>
  <div>
    <h2>{{ $t('views.locations.services.title') }}</h2>
    <div class="cards-container">
          <b-card v-for="entity in tableEntities" :key="entity.id" class="my-3" :title="entity.name" :sub-title="entity.description" bordered hover
            :img-src="entity.image">
            <b-form-checkbox
              v-model="entity.isActive"
              switch
              :id="`switch-${entity.id}`"
              @change="value => updateRelation('isactive', entity, value)">
              {{ entity.isActive ? $t('views.locations.services.subscribed') : $t('views.locations.services.notsubscribed') }}
            </b-form-checkbox>

            <div v-if="entity.configuration" class="configuration-list">
                <div v-for="(value, key) in entity.configuration" class="configuration-entry" :key="key">
                  <p class="label">{{ $t(`views.locations.services.configuration.${key}`) }}</p>
                  <p class="value">
                    <span v-if="typeof value === 'boolean'">
                      <span v-if="value">{{ $t(`views.locations.services.configuration.isMigratedFromDias_true`) }}</span>
                      <span v-else>{{ $t(`views.locations.services.configuration.isMigratedFromDias_false`) }}</span>
                    </span>
                    <span v-else>{{ value }}</span></p>
                </div>
            </div>

            <div v-if="entity._table" class="mt-2">
              <p>{{ entity._table.title }}</p>
            </div>
          </b-card>
        </div>
      </div>
</template>

<script>
import Table, { TableHelper } from '@/assets/js/helper/table'

import MixinEntityBase from '@/components/mixins/EntityBase'

const ENTITY_KEY = 'locationservices'
const RELATION_KEY = 'locationlocationservices'

export default {
  name: 'Locations.Services',
  mixins: [MixinEntityBase],
  components: {

  },
  data () {
    return {
      entityKey: ENTITY_KEY,
      relationKey: RELATION_KEY,
      table: {
        helper: TableHelper,
        options: {
          fields: {
            includes: [],
            excludes: [],
            sorting: ['subscribed', 'name', 'description'],
            sortable: ['name', 'description'],
            labelKey: 'views.locations.services.table.label.{field}',
            label: {},
            variant: {},
            class: {},
            thClass: {},
            tdClass: {}
          }
        }
      }
    }
  },
  computed: {
    is () {
      return this.$store.getters[`${this.eCurrent.key}/is`]
    },
    definition () {
      return this.$store.getters[`${this.eCurrent.key}/definition`]
    },
    entities () {
      console.log('eCurrent-Key', this.eCurrent.key)
      var x = this.$store.getters[`${this.eCurrent.key}/getUnwrapped`]
      console.log('eCurrent-Key', x)
      return x
    },
    relationsIs () {
      return this.$store.getters[`${this.relationKey}/is`]
    },
    relationsDefinition () {
      console.log('relationsDefinition')
      return this.$store.getters[`${this.relationKey}/definition`]
    },
    relations () {
      return this.$store.getters[`${this.relationKey}/getUnwrapped`]
    },
    tableEntities () {
      let previousCategoryKey = null

      return []
        .concat(this.entities)
        .sort(TableHelper.sortByProperties('category', `name.${this.$store.getters['gui/getLanguage']}`))
        .map(e => {
          const ENTITY = e
          const RELATION = this.relations.find(r => r.locationServiceId === ENTITY.id) || {}

          const CATEGORY_KEY = ENTITY.category || null
          const CATEGORY_TRANSLATIONS = ((((this.definition.$properties || {}).category || {}).translations || {})[this.$i18n.locale] || {}).selectValues || {}

          const _table = CATEGORY_KEY && CATEGORY_KEY !== previousCategoryKey ? { title: CATEGORY_TRANSLATIONS[CATEGORY_KEY] } : null

          previousCategoryKey = CATEGORY_KEY

          console.log('My Configuration', JSON.stringify(RELATION.configuration))

          return {
            _table,
            _entity: ENTITY,
            _relation: RELATION,
            id: ENTITY.id,
            isActive: RELATION.isActive || false,
            configuration: RELATION.configuration,
            name: getTranslatedValue.bind(this)(ENTITY.name),
            description: getTranslatedValue.bind(this)(ENTITY.description),
            hasRelation: RELATION.isActive !== undefined,
            status: ENTITY.status
          }
        })

      function getTranslatedValue (property = {}) {
        return property[this.$i18n.locale] || property[this.$i18n.fallbackLocale]
      }
    },
    tableData () {
      return new Table(this.tableEntities, this.table.options.fields)
    }
  },
  methods: {
    getEntities () {
      this.$store.dispatch(`${this.relationKey}/getAll`, { by: this.eParent })
      this.$store.dispatch(`${this.eCurrent.key}/getAll`)
    },
    updateRelation (key, item, value) {
      const action = item.hasRelation ? 'updateEntity' : 'createEntity'
      const id = item.hasRelation ? item._relation.id : undefined

      this.$store.dispatch(`${this.relationKey}/${action}`, {
        id,
        locationId: this.eParent.id,
        locationServiceId: item.id,
        isActive: value
      })
    }
  },
  created () {
    this.getEntities()
  }
}
</script>

<style lang="scss">
  .configuration-list {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #ccc;

    .configuration-entry {
      margin-bottom: 10px;

      .label {
        font-weight: bold;
        margin-bottom: 0;
      }

      .value {
        margin-bottom: 0;
        font-size: $font-size-xl;
      }
    }

  }

</style>
